import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../icon/Icon';

const WarningMessage = ({classNames, toastRef, children, dataQa}) => {
    return (
        <div className={classNames} ref={toastRef} data-qa={dataQa}>
            <Icon dimension="xl" iconName="danger" />
            <span className="ace-copy-m">{children}</span>
        </div>
    );
};

WarningMessage.propTypes = {
    classNames: PropTypes.string.isRequired,
    toastRef: PropTypes.object,
    dataQa: PropTypes.string,
};

WarningMessage.defaultProps = {
    toastRef: {},
    dataQa: 'toast-message',
};

export default WarningMessage;
